<script>
import {
  pageMonCompteMesListesDeCoursesDetailEmits,
  pageMonCompteMesListesDeCoursesDetailProps,
  usePageMonCompteMesListesDeCoursesDetail
} from "./mixin";
import StateOverlay from "@/components/molecules/state-overlay";
import ListeDeCoursesSupprimerProduit from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-supprimer-produit";
import ListeDeCoursesRenommer from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-renommer";
import ListesDeCoursesSupprimer from "@/components/organisms/mon-compte/listes-de-courses/listes-de-courses-supprimer";
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import Divider from "@/components/atoms/divider";
import Popin from "@/components/molecules/popin";
import CategoriesList from "@/containers/faire-mes-courses";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import ButtonIcon from "@/components/molecules/button-icon";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import CoursesExpressProductList from "@/components/organisms/mon-compte/courses-express-product-list/mobile";

import illustrationCrayonFeuilleZero from "@/assets/images/illustration-crayon-feuille-zero.svg";

export default {
  name: "ListesDeCoursesDetailMobile",
  components: {
    ListeDeCoursesSupprimerProduit,
    Card,
    Button,
    ButtonIcon,
    List,
    ListItem,
    CategoriesList,
    Divider,
    LazyImage,
    ListeDeCoursesRenommer,
    ListesDeCoursesSupprimer,
    Popin,
    Titre,
    StateOverlay,
    CoursesExpressProductList
  },
  props: {
    ...pageMonCompteMesListesDeCoursesDetailProps()
  },
  emits: [...pageMonCompteMesListesDeCoursesDetailEmits()],
  setup(props, context) {
    const supprimerProduit = ref(null);
    const supprimer = ref(null);
    const productList = ref(null);
    const renommer = ref(null);
    const {
      listes,
      isLoading,
      updateListeError,
      updateListeState,
      noProduct,
      dateLastUsageFormatted,
      deleteProduits,
      confirmDeleteListe,
      confirmDeleteProduits,
      addToCartListe,
      addToCartProduits,
      renameListe,
      mounted
    } = usePageMonCompteMesListesDeCoursesDetail(
      props,
      context,
      supprimerProduit,
      supprimer,
      productList,
      renommer
    );

    onMounted(async () => {
      await mounted();
    });

    return {
      listes,
      isLoading,
      updateListeError,
      updateListeState,
      noProduct,
      dateLastUsageFormatted,
      deleteProduits,
      confirmDeleteListe,
      confirmDeleteProduits,
      addToCartListe,
      addToCartProduits,
      renameListe,
      supprimerProduit,
      supprimer,
      productList,
      renommer,
      illustrationCrayonFeuilleZero
    };
  },
  methods: {
    changeListe(id) {
      this.$refs.changer.hide();
      navigateToInternal(`/mon-compte/mes-listes-de-courses/${id}`);
    }
  }
};
</script>

<template>
  <StateOverlay
    overlay
    :is-loading="isLoading || pageIsLoading"
  >
    <div
      v-if="liste"
      class="c-liste-de-courses-produits"
    >
      <ListeDeCoursesSupprimerProduit
        ref="supprimerProduit"
        slide-up
        :is-loading="isLoading"
        @confirmDelete="confirmDeleteProduits"
      />
      <ListeDeCoursesRenommer
        ref="renommer"
        slide-up
        :titre="liste.attributes.titre"
        :state="updateListeState"
        :error="updateListeError"
        @update="renameListe"
      />
      <ListesDeCoursesSupprimer
        ref="supprimer"
        slide-up
        :listes-to-delete="[liste]"
        :is-loading="isLoading"
        @confirmDelete="confirmDeleteListe"
      />
      <Popin
        ref="changer"
        aria-label="Changer de liste de courses"
        slide-up
      >
        <Titre
          tag="h1"
          variant="primary"
        >
          Changer de liste de courses
        </Titre>
        <List class="c-liste-de-courses-produits__list">
          <ListItem
            v-for="list in listes"
            :key="list.id"
            class="c-liste-de-courses-produits__list-item"
          >
            <Button
              full-width
              align="left"
              class="c-liste-de-courses-produits__list-item-button"
              @click="changeListe(list.id)"
            >
              {{ list.attributes.titre }}
            </Button>
          </ListItem>
        </List>
      </Popin>

      <Card class="u-p-sm u-border-y-border">
        <ButtonIcon
          icon-name="arrow-down"
          icon-position="right"
          class="c-liste-de-courses-produits__dropdown"
          @click="$refs.changer.show()"
        >
          <Titre tag="span">
            {{ liste.attributes.titre }}
          </Titre>
        </ButtonIcon>

        <p class="u-font-14 u-mb-xs u-mt-sm">
          {{ dateLastUsageFormatted }}
        </p>
        <Button
          link
          @click="$refs.renommer.show()"
        >
          Renommer
        </Button>
        <Button
          link
          class="u-ml-sm"
          @click="$refs.supprimer.show()"
        >
          Supprimer la liste
        </Button>

        <div
          v-if="noProduct"
          class="u-p-md"
        >
          <div class="u-text-center u-mb-md">
            <LazyImage
              :src="illustrationCrayonFeuilleZero"
              class="u-inline-block"
              width="92"
              height="88"
            />
            <p class="u-font-17 u-mt-md">
              Aucun produit dans votre liste
            </p>
          </div>
          <Divider dotted />
          <Titre
            tag="h2"
            variant="primary"
            class="u-mb-md u-mt-md u-text-center"
          >
            Commencez vos courses !
          </Titre>
          <CategoriesList />
        </div>

        <template v-else>
          <div class="u-flex u-flex-align-center u-mt-lg">
            <p class="u-font-17">
              <strong class="u-font-500">{{ liste.attributes.nb_produits }} {{ pluralize(liste.attributes.nb_produits, 'produit') }}</strong>
            </p>
            <Button
              variant="secondary"
              radius="full"
              size="md"
              class="u-ml-md"
              @click="addToCartListe"
            >
              Ajouter tout au panier
            </Button>
          </div>
        </template>
      </Card>

      <CoursesExpressProductList
        v-if="!noProduct"
        ref="productList"
        :cart-context="trackingCodes.LABELGA.ListeDeCourses"
        can-delete
        class="u-mt-md"
        :items="liste.attributes.produits.data"
        :sections="meta.sections.valeurs"
        :indisponibles="meta.items_indisponibles"
        @delete="deleteProduits"
        @addToCart="addToCartProduits"
      />
    </div>
  </StateOverlay>
</template>

<style lang="scss" scoped>
.c-liste-de-courses-produits .c-liste-de-courses-produits__dropdown {
  padding: 0;
}
.c-liste-de-courses-produits__list-item {
  border-bottom: 1px solid color(grey-6);
  &:last-child {
    border: none;
  }
}
.c-liste-de-courses-produits__list-item-button {
  padding-top: spacing(sm);
  padding-bottom: spacing(sm);
}
</style>
